// Used in notifications-sent.component.html

// Angular
import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
} from "@angular/core";
import { UntypedFormBuilder, Validators } from "@angular/forms";
import { OWL_DATE_TIME_FORMATS } from "@danielmoncada/angular-datetime-picker";

// Services/Types/Helpers
import { Notification } from "cli-types";

// Error State
import { MyErrorStateMatcher } from "./edit-notification.errorstate";

// https://momentjs.com/docs/#/displaying/
export const MY_CUSTOM_FORMATS = {
    parseInput: "L LT",
    fullPickerInput: "L LT",
    datePickerInput: "LL",
    timePickerInput: "LT",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
};

@Component({
    selector: "edit-notification",
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: "./edit-notification.component.html",
    styleUrls: [
        "../../notifications.component.scss",
        "./edit-notification.component.scss",
    ],
    providers: [
        {
            provide: OWL_DATE_TIME_FORMATS,
            useValue: MY_CUSTOM_FORMATS,
        },
    ],
    standalone: false
})
export class EditNotificationComponent implements OnInit {
    matcher = new MyErrorStateMatcher();

    @Input()
    notification?: Notification;

    @Output()
    save = new EventEmitter<Notification>();

    @Output()
    cancel = new EventEmitter<any>();

    notificationBody = "";

    working = false;

    // Toolbar configuration
    modules = {
        toolbar: [
            ["bold", "italic", "underline", "strike"], // toggled buttons

            [{ header: 1 }, { header: 2 }], // custom button values
            [{ list: "ordered" }, { list: "bullet" }],
            [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ["link"],
            [{ align: [] }],

            ["clean"], // remove formatting button
        ],
    };

    notificationForm = this.fb.group({
        // Not editable.
        noticeID: [null],

        body: ["", Validators.required],

        title: ["", Validators.required],

        displayAt: [null],
        expireAt: [null],
    });

    constructor(private fb: UntypedFormBuilder) {}

    ngOnInit() {
        if (this.notification) {
            this.notificationForm.patchValue(this.notification);
            this.notificationBody = this.notification.body;
        }
    }

    onClickSave() {
        if (this.notificationForm.valid) {
            this.working = true;
            this.save.emit(this.notificationForm.value);
        }
    }

    onClickCancel() {
        this.cancel.emit();
    }
}
